<template>
    <div class="saas-page engagement-page linear-command-page">
        <div class="saas-hero card-saas engagement-page__hero">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/home">{{ trans('general.home') }}</router-link>
                    <span class="px-1">/</span>
                    <span>{{ trans('lead.lead') }}</span>
                </p>
                <h1 class="saas-hero__title">{{ trans('lead.lead') }}</h1>
            </div>
            <div class="engagement-page__actions">
                <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" @click.prevent="showFilterPanel = !showFilterPanel">
                    <admin-icon name="sliders"></admin-icon> <span>{{ trans('general.filter') }}</span>
                </button>
            </div>
        </div>

        <div class="engagement-command-grid">
            <section class="engagement-command-card">
                <span>{{ trans('lead.lead') }}</span>
                <strong>{{ leads.total || 0 }}</strong>
                <p>{{ leads.total ? trans('general.total_result_found', { count: leads.total }) : trans('general.no_result_found') }}</p>
            </section>
            <section class="engagement-command-card engagement-command-card--muted">
                <span>{{ trans('lead.status') }}</span>
                <strong>{{ filterLeadForm.status || trans('general.select_one') }}</strong>
                <p>{{ trans('lead.source') }}: {{ filterLeadForm.source || '-' }}</p>
            </section>
            <section class="engagement-command-card engagement-command-card--muted">
                <span>{{ trans('general.sort_by') }}</span>
                <strong>{{ filterLeadForm.sort_by }}</strong>
                <p>{{ trans('general.order') }}: {{ filterLeadForm.order }}</p>
            </section>
        </div>

        <transition name="fade">
            <div class="card-saas engagement-filter-card" v-if="showFilterPanel">
                <div class="card-body">
                    <h4 class="card-saas__title">{{ trans('general.filter') }}</h4>
                    <div class="row">
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label>{{ trans('lead.keyword') }}</label>
                                <input class="form-control" v-model="filterLeadForm.keyword">
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label>{{ trans('lead.email') }}</label>
                                <input class="form-control" v-model="filterLeadForm.email">
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label>{{ trans('lead.source') }}</label>
                                <select class="form-control" v-model="filterLeadForm.source">
                                    <option value="">{{ trans('general.select_one') }}</option>
                                    <option value="demo">{{ trans('lead.demo') }}</option>
                                    <option value="contact">{{ trans('lead.contact') }}</option>
                                    <option value="partner">{{ trans('lead.partner') }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label>{{ trans('lead.status') }}</label>
                                <select class="form-control" v-model="filterLeadForm.status">
                                    <option value="">{{ trans('general.select_one') }}</option>
                                    <option value="new">{{ trans('lead.new') }}</option>
                                    <option value="contacted">{{ trans('lead.contacted') }}</option>
                                    <option value="qualified">{{ trans('lead.qualified') }}</option>
                                    <option value="won">{{ trans('lead.won') }}</option>
                                    <option value="lost">{{ trans('lead.lost') }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <date-range-picker :start-date.sync="filterLeadForm.start_date" :end-date.sync="filterLeadForm.end_date" :label="trans('general.date_between')"></date-range-picker>
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label>{{ trans('general.sort_by') }}</label>
                                <select class="form-control" v-model="filterLeadForm.sort_by">
                                    <option value="created_at">{{ trans('lead.created_at') }}</option>
                                    <option value="name">{{ trans('lead.name') }}</option>
                                    <option value="email">{{ trans('lead.email') }}</option>
                                    <option value="status">{{ trans('lead.status') }}</option>
                                    <option value="source">{{ trans('lead.source') }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label>{{ trans('general.order') }}</label>
                                <select class="form-control" v-model="filterLeadForm.order">
                                    <option value="asc">{{ trans('general.ascending') }}</option>
                                    <option value="desc">{{ trans('general.descending') }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <div class="admin-list-table-card mt-3" v-if="hasPermission('list-lead') && leads.total">
            <div class="table-responsive">
                <table class="table admin-data-table mb-0">
                    <thead>
                        <tr>
                            <sortable-th field="name" :sort-by="filterLeadForm.sort_by" :order="filterLeadForm.order" @sort="sortList">{{ trans('lead.name') }}</sortable-th>
                            <sortable-th field="email" :sort-by="filterLeadForm.sort_by" :order="filterLeadForm.order" @sort="sortList">{{ trans('lead.email') }}</sortable-th>
                            <th>{{ trans('lead.phone') }}</th>
                            <th>{{ trans('lead.school') }}</th>
                            <sortable-th field="source" :sort-by="filterLeadForm.sort_by" :order="filterLeadForm.order" @sort="sortList">{{ trans('lead.source') }}</sortable-th>
                            <sortable-th field="status" :sort-by="filterLeadForm.sort_by" :order="filterLeadForm.order" @sort="sortList">{{ trans('lead.status') }}</sortable-th>
                            <sortable-th field="created_at" :sort-by="filterLeadForm.sort_by" :order="filterLeadForm.order" @sort="sortList">{{ trans('lead.created_at') }}</sortable-th>
                            <th class="admin-table-actions-cell">{{ trans('general.actions') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="lead in leads.data" :key="lead.id">
                            <td>
                                <span class="engagement-table__primary" v-text="lead.name"></span>
                                <span class="engagement-table__meta">#{{ lead.id }}</span>
                            </td>
                            <td><span class="engagement-table__muted" v-text="lead.email"></span></td>
                            <td><span class="engagement-table__muted" v-text="lead.phone"></span></td>
                            <td><span class="engagement-table__muted" v-text="lead.school"></span></td>
                            <td v-html="getSource(lead)"></td>
                            <td v-html="getStatus(lead)"></td>
                            <td><span class="engagement-table__muted">{{ lead.created_at | moment }}</span></td>
                            <td class="admin-table-actions-cell">
                                <table-row-action-dropdown>
                                    <b-dropdown-item-button @click="openLeadDetail(lead)">
                                        <admin-icon name="eye"></admin-icon> {{ trans('lead.view') }}
                                    </b-dropdown-item-button>
                                    <b-dropdown-item-button
                                        v-if="hasPermission('delete-lead')"
                                        v-confirm="{ok: confirmDelete(lead)}"
                                        class="admin-row-actions__danger"
                                    >
                                        <admin-icon name="trash"></admin-icon> {{ trans('general.delete') }}
                                    </b-dropdown-item-button>
                                </table-row-action-dropdown>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="admin-table-pagination-wrap">
                <pagination-record :page-length.sync="filterLeadForm.page_length" :records="leads" @updateRecords="getLeads" @change.native="getLeads"></pagination-record>
            </div>
        </div>

        <div class="modal fade query-detail engagement-query-modal admin-modal-pro sip-view-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content admin-modal-pro__content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{ lead.name || trans('lead.lead') }}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body" v-if="lead">
                        <p class="sip-view-status__meta mb-3" v-if="lead.created_at">{{ lead.created_at | moment }}</p>
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <dl class="sip-view-dl">
                                    <div class="sip-view-dl__row"><dt>{{ trans('lead.email') }}</dt><dd>{{ lead.email }}</dd></div>
                                    <div class="sip-view-dl__row"><dt>{{ trans('lead.phone') }}</dt><dd>{{ lead.phone }}</dd></div>
                                    <div class="sip-view-dl__row"><dt>{{ trans('lead.school') }}</dt><dd>{{ lead.school }}</dd></div>
                                    <div class="sip-view-dl__row"><dt>{{ trans('lead.role') }}</dt><dd>{{ lead.role }}</dd></div>
                                    <div class="sip-view-dl__row"><dt>{{ trans('lead.city') }}</dt><dd>{{ lead.city }}</dd></div>
                                    <div class="sip-view-dl__row"><dt>{{ trans('lead.students') }}</dt><dd>{{ lead.students }}</dd></div>
                                    <div class="sip-view-dl__row"><dt>{{ trans('lead.source') }}</dt><dd>{{ lead.source }}</dd></div>
                                </dl>
                            </div>
                            <div class="col-12 col-sm-6" v-if="hasPermission('edit-lead')">
                                <h4 class="sip-view-section-title">{{ trans('lead.update_status') }}</h4>
                                <div class="form-group">
                                    <div class="admin-radio" v-for="item in statuses" :key="item">
                                        <input type="radio" :value="item" :id="'lead_status_'+item" v-model="status">
                                        <label :for="'lead_status_'+item"> {{ trans('lead.'+item) }} </label>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid" @click="updateStatus">{{ trans('general.save') }}</button>
                                </div>
                            </div>
                        </div>
                        <div class="sip-view-rich sip-view-thread__body" v-if="lead.message">{{ lead.message }}</div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" data-dismiss="modal">{{ trans('general.close') }}</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="admin-list-table-card admin-empty-state mt-3" v-if="!leads.total" role="status">
            <div class="admin-empty-state__inner">
                <div class="admin-empty-state__icon-wrap" aria-hidden="true">
                    <admin-icon name="user"></admin-icon>
                </div>
                <h4 class="admin-empty-state__title">{{ trans('lead.module_info_title') }}</h4>
                <p class="admin-empty-state__text">{{ trans('lead.module_info_description') }}</p>
            </div>
        </div>
    </div>
</template>
<script>
    import dateRangePicker from '../../components/date-range-picker'

    export default {
        components: { dateRangePicker },
        data() {
            return {
                leads: { total: 0, data: [] },
                filterLeadForm: {
                    keyword: '',
                    email: '',
                    status: '',
                    source: '',
                    start_date: '',
                    end_date: '',
                    order: 'desc',
                    sort_by: 'created_at',
                    page_length: helper.getConfig('page_length')
                },
                lead: {},
                showFilterPanel: false,
                status: 'new',
                id: '',
                statuses: ['new', 'contacted', 'qualified', 'won', 'lost']
            };
        },
        mounted() {
            this.getLeads();
        },
        methods: {
            getLeads(page) {
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterLeadForm);
                axios.get('/api/lead?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.leads = response)
                    .catch(error => helper.showDataErrorMsg(error));
            },
            openLeadDetail(lead) {
                axios.get('/api/lead/' + lead.id)
                    .then(response => response.data)
                    .then(response => {
                        this.lead = response;
                        this.status = response.status;
                        this.id = response.id;
                        this.$nextTick(() => {
                            if (window.$) {
                                window.$('.query-detail').modal('show');
                            }
                        });
                    })
                    .catch(error => helper.showDataErrorMsg(error));
            },
            confirmDelete(lead) {
                return dialog => this.deleteLead(lead);
            },
            deleteLead(lead) {
                axios.delete('/api/lead/' + lead.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getLeads();
                    }).catch(error => helper.showDataErrorMsg(error));
            },
            hasPermission(permission) {
                return helper.hasPermission(permission);
            },
            getStatus(lead) {
                let map = {
                    new: 'admin-status-badge--info',
                    contacted: 'admin-status-badge--warning',
                    qualified: 'admin-status-badge--success',
                    won: 'admin-status-badge--success',
                    lost: 'admin-status-badge--danger'
                };
                let cls = map[lead.status] || 'admin-status-badge--info';
                let label = i18n.lead[lead.status] || lead.status;
                return '<span class="admin-status-badge ' + cls + '">' + label + '</span>';
            },
            getSource(lead) {
                let label = i18n.lead[lead.source] || lead.source || '-';
                return '<span class="admin-status-badge">' + label + '</span>';
            },
            updateStatus() {
                axios.patch('/api/lead/' + this.id, { status: this.status })
                    .then(response => response.data)
                    .then(response => {
                        this.getLeads();
                        toastr.success(response.message);
                    }).catch(error => helper.showDataErrorMsg(error));
            },
            sortList(field) {
                if (this.filterLeadForm.sort_by === field) {
                    this.filterLeadForm.order = this.filterLeadForm.order === 'asc' ? 'desc' : 'asc';
                } else {
                    this.filterLeadForm.sort_by = field;
                    this.filterLeadForm.order = 'asc';
                }
            }
        },
        filters: {
            moment(date) {
                return helper.formatDateTime(date);
            }
        },
        watch: {
            filterLeadForm: {
                handler() { this.getLeads(); },
                deep: true
            }
        }
    }
</script>
<style scoped>
.linear-command-page {
    --linear-accent: #12363d;
    --linear-line: #e5e7ef;
    --linear-muted: #687083;
    --linear-ink: #111318;
}
.engagement-page__hero { align-items: center; }
.engagement-page__actions { display: flex; justify-content: flex-end; }
.engagement-command-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 0.9rem; margin: 1rem 0; }
.engagement-command-card { min-height: 112px; padding: 1rem; border: 1px solid var(--linear-line); border-radius: 18px; background: #fff; }
.engagement-command-card span { color: var(--linear-accent); font-size: 0.68rem; font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase; }
.engagement-command-card strong { display: block; margin-top: 0.45rem; color: var(--linear-ink); font-size: 1.45rem; font-weight: 800; }
.engagement-command-card p { margin: 0.35rem 0 0; color: var(--linear-muted); }
.engagement-filter-card { padding: 0; overflow: hidden; }
.engagement-filter-card .card-body { padding: 1rem 1.15rem; }
.engagement-table__primary { color: #0f172a; font-weight: 700; }
.engagement-table__meta { display: block; margin-top: 0.15rem; color: #94a3b8; font-size: 0.75rem; font-weight: 700; }
.engagement-table__muted { color: #64748b; }
@media (max-width: 991.98px) { .engagement-command-grid { grid-template-columns: 1fr; } }
</style>
